import i18next from 'i18next';

export function getTranslation(
  translations: { [key: string]: string },
  locale?: string,
): string {
  const lang = locale || i18next.language;
  return translations[lang] || translations['zh-Hant-HK'];
}
